import React, { useState, useRef, useEffect, useCallback } from "react";
import { GoogleMap, StandaloneSearchBox, useJsApiLoader, Marker } from "@react-google-maps/api";

const libraries = ["places"]; // Required for StandaloneSearchBox

const GoogleMapComponent = ({ setSelectedPlace, setAddressData, formData, mapsAPIkey, mapVisible }) => {
    const inputRef = useRef(null); // Reference for input field
    const mapRef = useRef(null); // Reference for Google Map
    const [mapCenter, setMapCenter] = useState({ lat: 40.7128, lng: -74.0060 }); // Default: New York
    const [zoom, setZoom] = useState(12);
    const [address, setAddress] = useState(null);
    const [count, setCount] = useState(0);
    const [manualEntry, setManualEntry] = useState(false);

    // Load Google Maps API
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: mapsAPIkey,
        libraries,
    });

    useEffect(() => {
        if (formData) {
            // setAddress(formData?.businessaddress)
            const lat = formData?.latitude ? formData?.latitude : 40.7128;
            const lng = formData?.longitude ? formData?.longitude : -74.0060;
            setMapCenter({
                lat, lng
            });
            // setCount(1)
        }


    }, [formData]);

    const processAddressComponents = (addressComponents) => {
        const addressData = {};

        addressComponents?.forEach(component => {
            const types = component.types;

            if (types.includes('street_number')) {
                addressData.street_number = component.long_name;
            } else if (types.includes('route')) {
                addressData.route = component.long_name;
            } else if (types.includes('locality')) {
                addressData.city = component.long_name;
            } else if (types.includes('administrative_area_level_1')) {
                addressData.state = component.long_name;
                addressData.stateShortName = component.short_name;
            } else if (types.includes('postal_code')) {
                addressData.postal_code = component.long_name;
            } else if (types.includes('sublocality_level_1')) {
                addressData.area = component.long_name;
            } else if (types.includes('administrative_area_level_2')) {
                addressData.county = component.long_name;
            }
        });

        return addressData;
    };



    // Convert Lat & Lng to Address (Reverse Geocoding)
    const getAddressFromLatLng = (lat, lng) => {
        const geocoder = new window.google.maps.Geocoder();
        const latLng = new window.google.maps.LatLng(lat, lng);

        geocoder.geocode({ location: latLng }, (results, status) => {
            if (status === "OK" && results[0]) {

                // // console.log('resultts ', results[0])
                const fullAddressData = processAddressComponents(results[0].address_components);

                const formattedAddress = {
                    url: results[0].url,
                    geolocation: results[0].geometry,
                    zipcode: fullAddressData.postal_code || '',
                    state: fullAddressData.state || fullAddressData.city || '',
                    stateShortName: fullAddressData.stateShortName || '',
                    address: `${fullAddressData.street_number || ''} ${fullAddressData.route || ''} ${fullAddressData.area || ''}`.trim(),
                    city: fullAddressData.city || '',
                    area: fullAddressData.area || '',
                    fullAddress: results[0].formatted_address || '',
                    county: fullAddressData.county?.includes(" County")
                        ? fullAddressData.county.replace(" County", "")
                        : fullAddressData.county,

                };

                // // console.log('formattedAddress ', formattedAddress)
                setAddress(results[0].formatted_address);
                setAddressData(formattedAddress);
                // setSelectedPlace(results[0].formatted_address);


            } else {
                console.error("Geocoder failed due to:", status);
            }
        });
    };

    // Function to handle place selection
    const handlePlacesChanged = () => {
        //  if (manualEntry) return;
        const places = inputRef.current.getPlaces();
        if (places?.length > 0) {
            const location = places?.[0]?.geometry.location;
            // console.log('places ', places, location.lat(), location.lng())
            setMapCenter({
                lat: location.lat(),
                lng: location.lng(),
            });
            setZoom(15);
            const fullAddressData = processAddressComponents(places?.[0]?.address_components);

            const formattedAddress = {
                url: places?.[0]?.url,
                geolocation: places?.[0]?.geometry,
                zipcode: fullAddressData.postal_code || '',
                state: fullAddressData.state || fullAddressData.city || '',
                stateShortName: fullAddressData.stateShortName || '',
                address: `${fullAddressData.street_number || ''} ${fullAddressData.route || ''} ${fullAddressData.area || ''}`.trim(),
                city: fullAddressData.city || '',
                area: fullAddressData.area || '',
                fullAddress: places?.[0]?.formatted_address || '',
                county: fullAddressData.county?.includes(" County")
                    ? fullAddressData.county.replace(" County", "")
                    : fullAddressData.county,

            };
            setAddress(places[0].formatted_address);
            setAddressData(formattedAddress);
            // setSelectedPlace(places[0].formatted_address);

            // getAddressFromLatLng(location.lat(), location.lng()); // Get address


        }
    };

    const handleInputChange = (event) => {
        const value = event.target.value;
        // // console.log("value", value)
        setAddress(value);
        setAddressData((prev) => ({ ...prev, fullAddress: value }));
        // setManualEntry(true);
    };
    // const handleKeyPress = (event) => {
    //     if (event.key === "Enter") {
    //         event.preventDefault(); // Prevent form submission if inside a form
    //         console.log("Entered Address:", address); // Log or process entered address
    //         handleManualAddressSubmit(); // Call a function to handle manual entry
    //     }
    // };
    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            event.preventDefault(); // Prevent form submission

            if (address.trim() !== "") {
                const formattedAddress = {
                    fullAddress: address.trim(),
                    address: address.trim(),
                    city: "", // User should enter city manually if needed
                    state: "", // Add state field manually
                    zipcode: "",
                    latitude: null,
                    longitude: null,
                    manualEntry: true, // Flag to indicate manual entry
                };


                setAddressData((prev) => ({
                    ...prev,
                    fullAddress: formattedAddress?.fullAddress,
                }));
                console.log("Address saved:", address);
                // setManualEntry(true);
                //setAddressData(formattedAddress?.fullAddress);
                console.log("Manual Address Entered:", formattedAddress);
            }
        }
    };


    const handleManualAddressSubmit = () => {
        if (address.trim() !== "") {
            setAddressData((prev) => ({
                ...prev,
                fullAddress: address.trim(),
            }));
            console.log("Address saved:", address);
        }
    };


    // When marker is dragged to a new position
    const handleMarkerDragEnd = (event) => {
        // console.log('event ', event.latLng.lat(), event.latLng.lng())
        setMapCenter({
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
        });

        getAddressFromLatLng(event.latLng.lat(), event.latLng.lng());
    };

    const handleMapClick = (event) => {
        setMapCenter({
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
        });
        getAddressFromLatLng(event.latLng.lat(), event.latLng.lng());
    };

    // Ensure map loads only when isLoaded is true
    if (!isLoaded) {
        return <div>Loading Google Maps...</div>;
    }


    // console.log(mapCenter, 'mapCenter',)
    // console.log('address ', address)
    // console.log(formData, 'formData',)
    return (
        <div className="map-style" style={{ width: "100%" }}>
            {/* Search Box */}
            <StandaloneSearchBox
                onLoad={(ref) => (inputRef.current = ref)}
                onPlacesChanged={handlePlacesChanged}
            >
                <input
                    type="text"
                    id="locationSearchInput"

                    placeholder="Search for a location"
                    value={address == null ? formData?.businessaddress : address}
                    className="form-control"
                    onChange={handleInputChange}
                    //  onKeyDown={handleKeyPress}
                    style={{
                        width: "91%",
                        height: "38px",
                        padding: "10px",
                        position: "absolute",
                        top: "0px",
                        left: "54%",
                        transform: "translateX(-50%)",
                        zIndex: 1000,
                        borderLeft: "none",
                        borderRadius: "0px 5px 5px 0px",
                        border: "1px solid #E2E8F0",
                    }}
                />

            </StandaloneSearchBox>


            {mapVisible &&
                <GoogleMap
                    mapContainerStyle={{ height: "400px", width: "100%" }}
                    center={mapCenter}
                    zoom={zoom}
                    onClick={handleMapClick}
                >
                    {/* <Marker position={mapCenter} /> */}
                    {/* Draggable Marker */}
                    <Marker
                        position={mapCenter}
                        draggable={true} // Allow dragging
                        onDragEnd={handleMarkerDragEnd} // Update position after drag
                    />
                </GoogleMap>}
        </div>
    );
};

export default GoogleMapComponent;
